<script setup lang="ts">
import { MonitoringObject } from "@/layouts/drawer/use-drawer-data";
import SiteSelectionFetcher from "./SiteSelectionFetcher.vue";
import StationSelectionFetcher from "./StationSelectionFetcher.vue";

const emit = defineEmits(["close"]);
const props = defineProps({
	id: { type: String, required: true },
	objectType: { type: String as PropType<MonitoringObject>, required: true },
});
const objectId = computed(() => props.id);
const object = computed(() => props.objectType);

function close() {
	emit("close");
}
</script>

<template>
	<SiteSelectionFetcher v-if="object === 'site'" :id="objectId" @close="close" />
	<StationSelectionFetcher v-else-if="object === 'station'" :id="objectId" @close="close" />
</template>
